var CascadeSetMappings = function () {
    this.GalleryKey                 = String;
    this.CascadeSet                 = String;
    this.Timestamp                  = Date; //Needs a better name.
    this.VisitDateFrom              = Date; //Now also caching on the visitdate filter values.
    this.VisitDateTo                = Date;
    this.Document                   = String;
    // this.GalleryKey$CascadeSet      = Composite(String);
 //   this.Gottcha = String; // changes to db structure should trigger database delete and page refresh
}

module.exports = CascadeSetMappings;